import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class HomepageStore {
  homepage = {};

  constructor(initialData) {
    makeAutoObservable(this);

    if (initialData) {
      this.homepage = initialData;
    }
  }

  setHomepage = (homepage) => {
    this.homepage = homepage;
  };

  get mobileVimeoId() {
    return this.homepage?.additionalConfiguration?.mobileVimeoId;
  }

  get desktopVimeoId() {
    return this.homepage?.additionalConfiguration?.desktopVimeoId;
  }

  get hasVideos() {
    return Boolean(this.mobileVimeoId && this.desktopVimeoId);
  }
}

export default HomepageStore;
